var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',[_c('v-col',{staticClass:"px-0",attrs:{"cols":"6"}},[_c('div',{staticStyle:{"max-height":"100vh"}},[_c('template1',{attrs:{"item":_vm.item,"name":"quotation"}})],1)])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }